<template>
  <div class="Vehicles">
    <div class="locale-toggle">
      <v-btn small depressed :color="currentLocale === 'en' ? 'primary' : ''" @click="setLocale('en')">EN</v-btn>
      <v-btn small depressed :color="currentLocale === 'ro' ? 'primary' : ''" @click="setLocale('ro')" class="ml-1">RO</v-btn>
    </div>
    <TrackerLocation :vehicle="{ licensePlate: 'TM37FUG', imei: '6028024308' }" :date="current_date" :locale="currentLocale"/>
  </div>
</template>

<script>
import TrackerLocation from '@/components/TrackerLocation.vue'

export default {
    name: 'Vehicles',
    components: {
        TrackerLocation
    },
    data: () => ({
        current_date: new Date().toISOString().slice(0,10)
    }),
    computed: {
        currentLocale() {
            return this.$route.query.locale === 'ro' ? 'ro' : 'en';
        }
    },
    methods: {
        setLocale(locale) {
            this.$router.push({ query: { ...this.$route.query, locale } });
        }
    }
}
</script>

<style>
.locale-toggle {
    display: flex;
    justify-content: flex-end;
    padding: 8px 16px;
}
</style>
